import * as HomePageActionTypes from '../actionTypes/HomePageActionTypes';

export const onPageReady = () => ({ // eslint-disable-line
    type: HomePageActionTypes.HOME_PAGE_LOAD_READY,
    payload: { pageName: 'home' },
});
